import {pageInfo, getIntData} from '../api';
import {cornSupplier, getAccessoryOrderStatus} from "../../../../../api";

const orderExport = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    accessoryOrderStatusObj: null,
    supplierObj: null,
    initDataObj: null
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []);
    },
    ACCESSORY_ORDER_STATUS(state, data) {
      state.accessoryOrderStatusObj = data;
    },
    SUPPLIER_DATA(state, data) {
      state.supplierObj = data;
    },
    INIT_DATA(state, data) {
      state.initDataObj = data.obj;
    },
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    //预约状态
    async getAccessoryOrderStatus({commit}, obj){
      let resp = await getAccessoryOrderStatus(obj);
      commit('ACCESSORY_ORDER_STATUS', resp);
    },
    //供应商
    async cornSupplier({commit}, obj){
      let resp = await cornSupplier(obj);
      commit('SUPPLIER_DATA', resp);
    },
    //查询详情
    async getIntData({commit}, obj){
      let resp = await getIntData(obj);
      commit('INIT_DATA', resp);
    },
  }
}
export default orderExport



// WEBPACK FOOTER //
// ./src/page/bd/accessory/orderExport/store/orderExport.store.js